import themeGet from '@styled-system/theme-get';
import * as T from 'prop-types';
import styled from 'styled-components/macro';

import { Flex, Icon, Text } from '@olist/united';

export const TitleWrapper = styled(Flex)`
  align-items: center;
`;

const Title = (props) => <Text ml={3} {...props} />;

const CurrentIcon = styled.div`
  background-color: ${themeGet('colors.foundation.primaryDefault')};
  border: 5px solid ${themeGet('colors.foundation.primaryLight')};
  border-radius: 50%;
  height: 15px;
  width: 15px;

  @media (max-width: ${themeGet('breakpoints.0')}) {
    display: none;
  }
`;

const StepTitle = ({ children, isBlocked, isCompleted, isCurrent, isWarning, ...props }) => {
  const blockedTitle = (
    <TitleWrapper {...props} data-testid="blocked">
      <Icon name="lock-fill" size="26px" color="foundation.shadeMedium" />
      <Title color="foundation.shadeDark">{children}</Title>
    </TitleWrapper>
  );
  const currentTitle = (
    <TitleWrapper {...props} data-testid="current">
      <CurrentIcon />
      <Title color="foundation.primaryDefault">{children}</Title>
    </TitleWrapper>
  );
  const completedTitle = (
    <TitleWrapper {...props} data-testid="completed">
      <Icon name="success-circle-fill" size="26px" color="foundation.successDefault" />
      <Title>{children}</Title>
    </TitleWrapper>
  );
  const warningTitle = (
    <TitleWrapper {...props} data-testid="warning">
      <Icon name="alert-circle-fill" size="26px" color="foundation.warningDefault" />
      <Title>{children}</Title>
    </TitleWrapper>
  );

  if (isWarning) return warningTitle;
  if (isCompleted) return completedTitle;
  if (isCurrent) return currentTitle;

  return isBlocked && blockedTitle;
};

StepTitle.propTypes = {
  /**
   * What are the StepTitle's children?
   */
  children: T.node.isRequired,
  /**
   * Is the step blocked?
   */
  isBlocked: T.bool,
  /**
   * Is the step completed?
   */
  isCompleted: T.bool,
  /**
   * Is the step the current step?
   */
  isCurrent: T.bool,
  /**
   * Does the step have a warning?
   */
  isWarning: T.bool,
};

StepTitle.defaultProps = {
  isBlocked: true,
  isCompleted: false,
  isCurrent: false,
  isWarning: false,
};

export default StepTitle;
